module.exports = __webpack_public_path__ + "img/truck-2.9ae28743.png";